"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-75d98012"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = { class: "OrderSummary" };
var _hoisted_2 = { class: "OrderSummary__top" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "heading2" }, "О заказе", -1); });
var _hoisted_4 = { class: "items" };
var _hoisted_5 = { class: "item" };
var _hoisted_6 = { class: "item__left" };
var _hoisted_7 = { class: "item__right" };
var _hoisted_8 = { class: "summary" };
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("div", { class: "summary__left" }, "Итого", -1); });
var _hoisted_10 = { class: "summary__right" };
var _hoisted_11 = /*#__PURE__*/ vue_2.createTextVNode("Перейти к оформлению");
exports.default = vue_1.defineComponent({
    props: {
        editable: { type: Boolean },
        summary: null,
        items: null
    },
    emits: ['clear'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            var _component_router_link = vue_2.resolveComponent("router-link");
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                vue_2.createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (props.editable)
                        ? (vue_2.openBlock(), vue_2.createElementBlock("div", {
                            key: 0,
                            class: "link",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (emit('clear')); })
                        }, "Очистить"))
                        : vue_2.createCommentVNode("", true)
                ]),
                vue_2.createElementVNode("div", _hoisted_4, [
                    (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(__props.items, function (item) {
                        return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_5, [
                            vue_2.createElementVNode("div", _hoisted_6, vue_2.toDisplayString(item.title), 1),
                            vue_2.createElementVNode("div", _hoisted_7, vue_2.toDisplayString(item.value), 1)
                        ]));
                    }), 256))
                ]),
                vue_2.createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    vue_2.createElementVNode("div", _hoisted_10, vue_2.toDisplayString(__props.summary), 1)
                ]),
                (props.editable)
                    ? (vue_2.openBlock(), vue_2.createBlock(_component_router_link, {
                        key: 0,
                        to: "/order/orderCheck/",
                        class: "default-btn OrderSummary__btn"
                    }, {
                        default: vue_2.withCtx(function () { return [
                            _hoisted_11
                        ]; }),
                        _: 1
                    }))
                    : vue_2.createCommentVNode("", true)
            ]));
        };
    }
});
